/*
 *
 * LanguageProvider constants
 *
 */

export const CHANGE_LOCALE = 'app/LanguageToggle/CHANGE_LOCALE';



// WEBPACK FOOTER //
// ./app/containers/LanguageProvider/constants.js